export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13498.a404d0ea.jpg";